import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { OnlineStripContent, StoreType } from 'src/app/models';
import { HomeType } from 'src/app/models/home';
import { ContentService } from 'src/app/services/content/content.service';
import { StripContainerComponent } from 'src/app/shared/layout/strips/strip-container.component';
import { HomeFancyComponent } from './home-fancy/home-fancy.component';
import { HomeMenyComponent } from './home-meny/home-meny.component';
import { HomeSimpleComponent } from './home-simple/home-simple.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HomeSimpleComponent, HomeMenyComponent, HomeFancyComponent, StripContainerComponent],
})
export class HomeComponent implements OnInit {
  private contentService = inject(ContentService);

  homeType: HomeType;

  strips: OnlineStripContent[];

  ngOnInit() {
    this.homeType = HomeType.simple;
    const type = this.contentService.getMerchant()?.type;
    if (type === StoreType.MENY || type === StoreType.SPAR || type === StoreType.MIN_KOBMAND) {
      this.homeType = HomeType.meny;
    } else if (this.contentService.get(HomeType.fancy)?.size) {
      this.homeType = HomeType.fancy;
    }

    this.strips = this.contentService.getOnlineHomeContent();
  }

  get HomeType(): typeof HomeType {
    return HomeType;
  }
}
